/** Metadados (filter-options, max-date) — mudam pouco no dia. */
export const STALE_TIME_METADATA_MS = 10 * 60 * 1000;

/** Séries de gráficos do dashboard. */
export const STALE_TIME_CHART_MS = 3 * 60 * 1000;

/** Painel de indicadores agregado. */
export const STALE_TIME_PANEL_MS = 2 * 60 * 1000;

/** Contador de notificações não lidas. */
export const STALE_TIME_NOTIFICATION_COUNT_MS = 45 * 1000;

export const STALE_TIME_CUSTOMERS_ME_MS = 5 * 60 * 1000;

export const STALE_TIME_AUTH_ME_MS = 5 * 60 * 1000;

export const STALE_TIME_ADMIN_PENDING_MS = 60 * 1000;

export const GC_TIME_DEFAULT_MS = 20 * 60 * 1000;
